import permissions from './permission-list'

export default [
  {
    path: '/articles',
    name: 'articles',
    component: () => import('@/views/articles/index.vue'),
    meta: {
      pageTitle: 'Daftar Artikel',
      resource: permissions.article,
      action: 'read',
      navActiveLink: 'articles',
      breadcrumb: [
        {
          text: 'Artikel',
          active: true,
        },
      ],
    },
  },
  {
    path: '/articles/create',
    name: 'articles-create',
    component: () => import('@/views/articles/create.vue'),
    meta: {
      pageTitle: 'Buat Artikel',
      resource: permissions.article,
      action: 'manage',
      navActiveLink: 'articles',
      breadcrumb: [
        {
          text: 'Artikel',
          active: false,
          to: { path: '/articles' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/articles/:id/edit',
    name: 'articles-edit',
    component: () => import('@/views/articles/edit.vue'),
    meta: {
      pageTitle: 'Edit Artikel',
      resource: permissions.article,
      action: 'manage',
      navActiveLink: 'articles',
      breadcrumb: [
        {
          text: 'Artikel',
          active: false,
          to: { path: '/articles' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
